import React from 'react';

export default function UserIcon(props) {
  return (
    <svg width={props.width || "18"} height={props.height || "20"} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2222 18C16.2222 16.7595 16.2222 16.1392 16.0691 15.6345C15.7244 14.4982 14.8352 13.6089 13.6988 13.2642C13.1941 13.1111 12.5738 13.1111 11.3333 13.1111H6.88889C5.64839 13.1111 5.02814 13.1111 4.52343 13.2642C3.38707 13.6089 2.49781 14.4982 2.1531 15.6345C2 16.1392 2 16.7595 2 18M13.1111 6C13.1111 8.20914 11.3203 10 9.11111 10C6.90197 10 5.11111 8.20914 5.11111 6C5.11111 3.79086 6.90197 2 9.11111 2C11.3203 2 13.1111 3.79086 13.1111 6Z" stroke={props.stroke || "#5A646E"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
